import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { CoreModule } from 'world-archery-lib';
import { SharedModule } from '../shared/shared.module';
import { FiltersSeriesTeamsService } from './filters-series-teams.service';
import { FiltersSeriesTeamsComponent } from './filters-series-teams/filters-series-teams.component';
import { IndoorTeamsBootstrapComponent } from './indoor-teams-bootstrap/indoor-teams-bootstrap.component';
import { IndoorWorldSeriesListComponent } from './indoor-world-series-list/indoor-world-series-list.component';
import { IndoorWorldSeriesTeamInfoComponent } from './indoor-world-series-team-info/indoor-world-series-team-info.component';
import { IndoorWorldSeriesTeamComponent } from './indoor-world-series-team/indoor-world-series-team.component';
import { IndoorWorldSeriesTeamsRoutingModule } from './indoor-world-series-teams-routing.module';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';

@NgModule({
  bootstrap: [],
  imports: [
    CommonModule,
    IndoorWorldSeriesTeamsRoutingModule,
    FormsModule,
    CoreModule,
    SharedModule,
    CommonPageComponentsModule
  ],
  declarations: [
    IndoorWorldSeriesTeamComponent,
    IndoorWorldSeriesTeamInfoComponent,
    IndoorWorldSeriesListComponent,
    IndoorTeamsBootstrapComponent,
    FiltersSeriesTeamsComponent
  ],
  providers: [FiltersSeriesTeamsService]
})
export class IndoorWorldSeriesTeamsModule { }
